export const LanguageKeys = {
    english: 'en',
    afrikaans: 'af',
    russian: 'ru',
    french: 'fr',
    spanish: 'es',
    romanian: 'ro',
    hebrew: 'he',
    bulgarian: 'bg'
};
